module.exports = __webpack_public_path__ + "img/gp.85556bea.svg";